//@flow
export const PROJECT_TOUR_DISPLAYED = "wizards/PROJECT_TOUR_DISPLAYED";
